import { StylisPlugin } from 'styled-components'
import stylisRTLPlugin from 'stylis-plugin-rtl'

import { Direction } from '@mui/material/styles'

export const getStylisPlugins = (direction: Direction): StylisPlugin[] =>
    direction === 'rtl' ? [stylisRTLPlugin as unknown as StylisPlugin] : []
